import { useEffect, useRef, useState } from "react";

export function useMinimumVisibleLoading(
  isLoading: boolean,
  minimumMs = 400
): boolean {
  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef<number | null>(null);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isLoading) {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      shownAtRef.current = Date.now();
      setVisible(true);
      return;
    }

    const shownAt = shownAtRef.current;
    if (shownAt === null) {
      return;
    }

    const remaining = minimumMs - (Date.now() - shownAt);
    hideTimeoutRef.current = setTimeout(
      () => {
        hideTimeoutRef.current = null;
        shownAtRef.current = null;
        setVisible(false);
      },
      Math.max(0, remaining)
    );

    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
  }, [isLoading, minimumMs]);

  return visible;
}
